const nowInUTC: () => string = () => {
  const date = new Date().toISOString();

  return `${date.split('.')[0]}Z`
}

export default nowInUTC;